/**
 * @func iterateObject
 * @param {object} object - object to iterate over.
 * @param {object} props - object containing filterByKey, filterByValue, mapKeys, and mapValues methods
 * @return {object}
 * @desc Allows for filtering and mapping of an object.
 * ```js
 * const object = { age: 104, firstName: 'brendor', lastName: 'brownbags' };
 *
 * const result = iterateObject(object, {
 *    filterByKey: key => key.includes('Name'),
 *    mapValues: value => capitalize(value),
 * })
 *
 * // result === { firstName: 'Brendor', lastName: 'Brownbags' }
 * ```
 * @memberof module:Object
 * @instance
 */
function iterateObject(object, props = {}) {
    /* eslint-disable @typescript-eslint/explicit-function-return-type */
    const filterByKey = props.filterByKey || (() => true);
    const filterByValue = props.filterByValue || (() => true);
    const mapKeys = props.mapKeys || (key => key);
    const mapValues = props.mapValues || (value => value);
    /* eslint-enable */
    const filtered = Object.entries(object)
        .filter(([key, value]) => filterByKey(key) && filterByValue(value))
        .reduce((hash, [key, value]) => (Object.assign(Object.assign({}, hash), { [key]: value })), {});
    const mapped = Object.entries(filtered).reduce((hash, [key, value]) => (Object.assign(Object.assign({}, hash), { [mapKeys(key)]: mapValues(value) })), {});
    return mapped;
}

export { iterateObject as default };
